<template>
    <div class="form-group">
        <div class="col-md-9 col-md-offset-3">
            <div class="embed-map mt-3" id="m"></div>

            <p class="mt-3 mb-0 text-muted">Polohu inštitúcie je možné upresniť potiahnutím bodu na mape.</p>
        </div>
    </div>
</template>

<script>
    export default {
        props: ['lat', 'long', 'institutionId'],

        mounted: function () {
            let vm = this;

            function updateInstititutionMap(long, lat) {
                axios.patch('/admin/institutions/' + vm.institutionId + '/update-gps', {
                    lat: lat,
                    long: long,
                }).then(flash('Poloha bola uložená.'))
                    .catch(error => flash('Polohu sa nepodarilo uložiť.', 'danger'));
            }

            var center = SMap.Coords.fromWGS84(vm.long, vm.lat);
            var m = new SMap(JAK.gel("m"), center, 16);
            // m.addDefaultControls();
            m.addDefaultLayer(SMap.DEF_BASE).enable();
            var mouse = new SMap.Control.Mouse(SMap.MOUSE_PAN | SMap.MOUSE_WHEEL | SMap.MOUSE_ZOOM); /* Ovládání myší */
            m.addControl(mouse);

            var l = new SMap.Layer.Marker();
            m.addLayer(l).enable();

            var mark = new SMap.Marker(center);
            mark.decorate(SMap.Marker.Feature.Draggable);
            l.addMarker(mark);

            function start(e) { /* Začátek tažení */
                var node = e.target.getContainer();
                node[SMap.LAYER_MARKER].style.cursor = "help";
            }

            function stop(e) {
                var node = e.target.getContainer();
                node[SMap.LAYER_MARKER].style.cursor = "";
                var coords = e.target.getCoords();
                updateInstititutionMap(coords.x, coords.y);
            }

            var signals = m.getSignals();
            signals.addListener(window, "marker-drag-stop", stop);
            signals.addListener(window, "marker-drag-start", start);
        }
    }
</script>
